import { Card, CardActionArea, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";
import type { Theme } from "../../constants/themeConstants";

export const ServiceCardContainer = styled(Link)`
  && {
    text-decoration: none;
    min-height: 200px;
    width: 100%;
    border-bottom: 8px solid ${(props) => (props.theme as Theme).colors.primary};

    /* @media (min-width: 1216px) {
      &:nth-last-child(-n + 4) {
        max-width: 268px;
      }
    }*/
  }
`;

export const StyledCard = styled(Card)`
  && {
    width: 100%;
    height: 100%;
    border-radius: 0;
    box-shadow: none;
    --Paper-shadow: none;
    cursor: pointer;
  }
`;

export const TitleOverlay = styled(Typography)`
  && {
    position: relative;
    z-index: 2;

    gap: 10px;
    margin: 32px 16px;
    padding: 12px;
    width: fit-content;

    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    color: ${(props) => (props.theme as Theme).colors.textColor};
    font-weight: 700;
    font-size: 32px;
    line-height: 100%;
    letter-spacing: 0;

    user-select: none;
  }
`;

export const CardMediaWrapper = styled(CardActionArea)`
  && {
    height: inherit;

    &:hover {
      .MuiCardActionArea-focusHighlight {
        opacity: 0;
      }
      ${TitleOverlay} {
        background-color: ${(props) =>
          (props.theme as Theme).colors.white}; //70;
      }
    }
    &:not(:hover) {
      .MuiCardActionArea-focusHighlight {
        opacity: 0.7;
        color: white;
      }
      ${TitleOverlay} {
        background-color: transparent;
      }
    }
  }
`;
